/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function GestionInventario() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="success"
                borderRadius="lg"
                coloredShadow="success"
              >
                <MDTypography variant="h6" color="white">
                  Gestión de Inventario
                </MDTypography>
              </MDBox>
              <MDBox pt={3} pb={3} px={3}>
                <MDTypography variant="h5" fontWeight="medium" color="text" mb={2}>
                  Bienvenido a Gestión de Inventario
                </MDTypography>
                <MDTypography variant="body2" color="text">
                  En esta sección puedes gestionar el inventario de tests disponibles para las empresas.
                  Utiliza el menú lateral para acceder a las diferentes opciones de gestión.
                </MDTypography>
                
                <Grid container spacing={3} mt={3}>
                  <Grid item xs={12} md={6}>
                    <Card sx={{ p: 3 }}>
                      <MDTypography variant="h6" fontWeight="medium" color="success" mb={2}>
                        Test Disponibles
                      </MDTypography>
                      <MDTypography variant="body2" color="text">
                        Gestiona la cantidad y precios de los tests disponibles para cada empresa.
                        Controla el estado activo/inactivo de las empresas.
                      </MDTypography>
                    </Card>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Card sx={{ p: 3 }}>
                      <MDTypography variant="h6" fontWeight="medium" color="success" mb={2}>
                        Control de Inventario
                      </MDTypography>
                      <MDTypography variant="body2" color="text">
                        Aumenta o disminuye la cantidad de tests, edita precios y mantén 
                        actualizado el inventario de cada empresa.
                      </MDTypography>
                    </Card>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default GestionInventario; 